import { takeLatest, call, put } from 'redux-saga/effects'
import allCoursesList from 'api/home/AllCourses'
import * as fromActions from '../../actions/courses.action'

async function getAllCoursesList() {
  return await allCoursesList()
}

function* AllCoursesListEffectSaga() {
  try {
    const data = yield call(getAllCoursesList)
    yield put(fromActions.Actions.coursesUserAllListSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* allCoursesListWatcherSaga() {
  yield takeLatest(
    fromActions.COURSES_USER_GET_ALL_LIST,
    AllCoursesListEffectSaga
  )
}
